import { qs, qsa, add, remove } from "@fluorescent/dom";
import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  partial: "[data-partial]",
  productItems: ".product-item:not(.animation--item-revealed)",
};

const classes = {
  hideProducts: "animation--collection-products-hide",
  itemRevealed: "animation--item-revealed",
};

export default node => {
  if (!shouldAnimate(node)) return;
  const observer = intersectionWatcher(node);
  const partial = qs(selectors.partial, node);

  setupProductItem();

  function setupProductItem() {
    let productItems = qsa(selectors.productItems, node);
    delayOffset(node, [selectors.productItems], 1);
    setTimeout(() => {
      add(productItems, classes.itemRevealed);
    }, 50);
  }

  function updateContents() {
    setupProductItem();
    // Remove the fade out class
    remove(partial, classes.hideProducts);
  }

  function infiniteScrollReveal() {
    setupProductItem();
  }

  return {
    updateContents,
    infiniteScrollReveal,
    destroy() {
      observer?.destroy();
    },
  };
};
